import {
  createMuiTheme,
  CssBaseline,
  Drawer,
  makeStyles,
  ThemeProvider,
} from "@material-ui/core";
import React from "react";
import Header from "../../../components/Admin/Header";
import red from "@material-ui/core/colors/red";
import MyDrawer from "../../../components/Admin/Drawer";
import { SpecProvider } from "../../../components/Specialities/SpecContext";
import Spec from "./Spec";
import { useStyles, theme } from "../theme.js";

const SpecAdminPage = (props) => {
  const classes = useStyles();

  return (
    <SpecProvider>
      <ThemeProvider theme={theme}>
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
          anchor="left"
        >
          <MyDrawer></MyDrawer>
        </Drawer>
        <div className={classes.adminMain}>
          <Header></Header>
          <Spec></Spec>
        </div>
        <CssBaseline></CssBaseline>
      </ThemeProvider>
    </SpecProvider>
  );
};

export default SpecAdminPage;
